module.exports = __webpack_public_path__ + "img/pic14.f1a3b74b.png";